module.exports = __webpack_public_path__ + "media/images/icons/fire-3feccd465a6bec16c2f7780a903173e6.svg";